////////////////////////////////////////////////////////////////////
// This file contains configs that add analytics integrations     //
////////////////////////////////////////////////////////////////////

// Note: These come from the analytics asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeAnalyticsConfig func)

// Keep the pixel out of local runs even when .env carries the live id. Both
// conditions are needed: NODE_ENV catches `yarn run dev`, the root URL catches
// a local production build, which is NODE_ENV=production on localhost.
//
// Read the env var, not config.marketplaceRootURL - that is pinned to
// https://toastably.com by the override in configDefault.js, so it is never
// localhost. Keep in sync with server/api-util/facebookPixel.js.
const isLocalhostRootURL = rootURL => /^https?:\/\/localhost(:\d+)?(\/|$)/.test(rootURL || '');

const isAnalyticsEnabled = () =>
  process.env.NODE_ENV === 'production' &&
  !isLocalhostRootURL(process.env.REACT_APP_MARKETPLACE_ROOT_URL);

// Optional
// Note that Google Analytics might need advanced opt-out option / cookie consent
// depending on jurisdiction (e.g. EU countries), since it relies on cookies.
export const googleAnalyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

// Optional
// Meta (Facebook) Pixel. Set REACT_APP_FACEBOOK_PIXEL_ID to enable it.
// Note: like Google Analytics, this relies on cookies, so it may need a cookie
// consent / opt-out flow depending on jurisdiction (e.g. EU/CH).
export const facebookPixelId = isAnalyticsEnabled()
  ? process.env.REACT_APP_FACEBOOK_PIXEL_ID
  : null;

// Optional
// If you add this Plausible integration, you should first create an account in plausible.io
// This adds data-domains for Plausible script through environment variable: REACT_APP_PLAUSIBLE_DOMAINS
// https://plausible.io/docs/plausible-script#can-i-send-stats-to-multiple-dashboards-at-the-same-time
// You can add multiple domains separated by comma
// E.g. REACT_APP_PLAUSIBLE_DOMAINS=example1.com,example2.com
export const plausibleDomains = process.env.REACT_APP_PLAUSIBLE_DOMAINS;
